'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setFilter = setFilter;
exports.clearFilters = clearFilters;
var SET_FILTER = exports.SET_FILTER = 'SET_FILTER';
var CLEAR_FILTERS = exports.CLEAR_FILTERS = 'CLEAR_FILTERS';

function setFilter(fieldName, values) {
  return {
    type: SET_FILTER,
    fieldName: fieldName,
    values: values
  };
}

function clearFilters() {
  return {
    type: CLEAR_FILTERS
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Filters/actions.js
// module id = 146
// module chunks = 0